import { ArrowLeftIcon, Label, TextInput } from 'flowbite-react';
import React, { useState } from 'react';
import { ForgetPasswordMeta, LoadingSpinnerMeta } from '../data'
import { Button, Card, LoadingSpinner, SplitBackgroundLayout } from '../components';
import { Link } from 'react-router-dom';


//const API_BASE_URL = `http://localhost:8000/api`;
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000/api';

function ForgetPassword() {
    const meta = ForgetPasswordMeta
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const [success, setSuccess] = useState<string | null>(null);

    const [formData, setFormData] = useState({
        email: ""
    });

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);
        setSuccess(null);
        setLoading(true);

        const loginData = {
                email: formData.email
            };

       try {
            const response = await fetch(API_BASE_URL + '/auth/forget',
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest'
                },
                credentials: 'include',
                body: JSON.stringify(loginData)
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.message || 'Failed to send reset email.');
            }

            const data = await response.json();
            const message = data.message || 'Password reset link sent. Please check your email.';
            setSuccess(message);

        } catch (e) {
            setError(e instanceof Error ? e.message : 'Invalid email.');

        } finally {
            setLoading(false);
        }
    };

    return (
        <SplitBackgroundLayout>
            {loading && (
                <div className="absolute top-4 flex justify-center items-center w-full">
                    <LoadingSpinner meta={LoadingSpinnerMeta} />
                </div>
            )}

            <Card className="w-full max-w-sm shadow-lg p-4">
                <div className="text-sm font-medium text-gray-500 dark:text-gray-300 text-start">
                    <Link to="/international/login" className='flex items-center gap-2'><ArrowLeftIcon className='w-4 h-4' /> {meta.back}</Link>
                </div>

                {error && (
                    <div className="w-full max-w-sm mb-4">
                        <div className="bg-danger-500/10 border border-danger-500 text-danger-500 px-6 py-4 rounded-lg">
                            <p className="font-bold text-lg mb-2">{meta.errorLabel}</p>
                            <p>{error}</p>
                        </div>
                    </div>
                )}

                {success && (
                    <div className="w-full max-w-sm mb-4">
                        <div className="bg-success-500/10 border border-success-500 text-success-500 px-6 py-4 rounded-lg">
                            <p className="font-bold text-lg mb-2">{meta.successLabel}</p>
                            <p className="mt-2 text-sm">{meta.successMessage}</p>
                        </div>
                    </div>
                )}

                <h3 className="text-xl font-bold text-gray-900 dark:text-white text-center mb-0">
                    {meta.title}
                </h3>

                <form className="flex flex-col gap-4" onSubmit={handleSubmit}>
                    {/* Email Input */}
                    <div>
                        <div className="mt-2 mb-1 block">
                            <Label htmlFor="email">{meta.emailLabel}</Label>
                        </div>
                        <TextInput
                            id="email"
                            type="email"
                            name="email"
                            placeholder={meta.emailPlaceholder}
                            value={formData.email}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    <Button type="submit">
                        {meta.sendResetLink}
                    </Button>
                </form>
            </Card>
        </SplitBackgroundLayout>
    );
}

export default ForgetPassword;

